import { AccountMembershipTaskDefinition } from 'modules/inbox_tasks/tasks/accountMembership'
import { ApprovalTaskDefinition } from 'modules/inbox_tasks/tasks/approval'
import { ApprovalsV2TaskDefinition } from 'modules/inbox_tasks/tasks/approvalsv2'
import { DocumentTaskDefinition } from 'modules/inbox_tasks/tasks/documentTask'
import { EmployeeLifecycleStepActionTaskDefinition } from 'modules/inbox_tasks/tasks/employeeLifecycleStepAction'
import { EmployeeUpdateTaskDefinition } from 'modules/inbox_tasks/tasks/employeeUpdates'
import { FillDocumentTaskDefinition } from 'modules/inbox_tasks/tasks/fillDocument'
import { FillFormTaskDefinition } from 'modules/inbox_tasks/tasks/fillForm'
import { PeerAssignmentTaskDefinition } from 'modules/inbox_tasks/tasks/peerAssignment'
import { PolicyAcknowledgementTaskDefinition } from 'modules/inbox_tasks/tasks/policyAcknowledgement'
import { ReviewEvaluationTaskDefinition } from 'modules/inbox_tasks/tasks/reviewEvaluation'
import { SignatureTaskDefinition } from 'modules/inbox_tasks/tasks/signature'
import { SurveyQuestionGroupTaskDefinition } from 'modules/inbox_tasks/tasks/surveyQuestionGroup'
import { TerminateEmployeeTaskDefinition } from 'modules/inbox_tasks/tasks/terminateEmployee'
import { WorkflowHandlerExecutionTaskDefinition } from 'modules/inbox_tasks/tasks/workflows'

export const getTaskDefinitions = () => {
  const definitions = [
    ApprovalTaskDefinition,
    ApprovalsV2TaskDefinition,
    SignatureTaskDefinition,
    ReviewEvaluationTaskDefinition,
    FillDocumentTaskDefinition,
    PeerAssignmentTaskDefinition,
    EmployeeUpdateTaskDefinition,
    EmployeeLifecycleStepActionTaskDefinition,
    FillFormTaskDefinition,
    WorkflowHandlerExecutionTaskDefinition,
    DocumentTaskDefinition,
    TerminateEmployeeTaskDefinition,
    SurveyQuestionGroupTaskDefinition,
    PolicyAcknowledgementTaskDefinition,
    AccountMembershipTaskDefinition,
  ]

  definitions.forEach((definition) => {
    const isValidDefinition =
      definition && typeof definition === 'object' && 'taskableTypename' in definition

    if (!isValidDefinition) {
      throw new Error(`Invalid task definition: ${definition}`)
    }
  })

  return definitions
}

type GetTaskDefinitionsResult = ReturnType<typeof getTaskDefinitions>

export type TaskDefinition = GetTaskDefinitionsResult[number]
